import React from "react";
import module from "./Faq.module.css";
import { Container, Divider } from "@mui/material";

const Faq = () => {
  const ChildQuestions = ({ title, desc, image, imageName }) => (
    <>
      <li>{title}</li>
      <div>
        <span>{desc}</span>
      </div>
      {image && (
        <div className={module.wrapImage}>
          <img
            src={`${process.env.PUBLIC_URL}/${image}`}
            alt={imageName}
            className={module.image}
          />
        </div>
      )}
    </>
  );
  return (
    <div className={module.container}>
      <div>
        <h1 className={module.title}>よくあるご質問</h1>
      </div>
      <Divider />
      <Container
        sx={{
          padding: "0px",
        }}
      >
        <div className={module.contents}>
          <h2>プログラム参加について</h2>
          <ul>
            <ChildQuestions
              title={"プログラムに参加するには費用が発生しますか？"}
              desc={
                "ナッシュアンバサダープログラムは、会員登録やその他費用は一切発生することはございません。"
              }
            />
            <ChildQuestions
              title={"プログラムに参加するには何か手続きは必要ですか？"}
              desc={
                "ナッシュアンバサダープログラムは、お手続等は一切不要です。ダッシュボードのQRコードやURLをSNS等でシェア頂くだけとなります。"
              }
            />
          </ul>
          <h2>報酬について</h2>
          <ul>
            <ChildQuestions
              title={"報酬はどのタイミングで発生しますか？"}
              desc={
                "報酬は紹介された方が、実際にナッシュをご購入後にお受け取り頂くと報酬が発生いたします。"
              }
            />
            <ChildQuestions
              title={"何名紹介しても報酬は発生しますか？"}
              desc={
                "はい、紹介数の制限は無く何名ご紹介頂いても、1名につき報酬が発生いたします。"
              }
            />
            <ChildQuestions
              title={"同じ方が2回以上購入しても報酬は発生しますか？"}
              desc={
                "報酬は初回購入のみ発生いたします。同じ方が2回購入された場合は報酬対象外となります。尚、過去ナッシュをお届けしたことがある住所・電話番号についても対象外となります。"
              }
            />
            <ChildQuestions
              title={
                "実績が正常に反映しない場合はどうすればよいですか？"
              }
              desc={
                <div>
                  <p>1. 過去の実績を確認する方法はこちらです</p>
                  <div className={module.listDetail}>
                    <Divider />
                    ①アンバサダーのマイページからレポートの詳細を押す<br />
                    ②報酬履歴画面へ飛ぶ<br />
                    ③画面タブで未振込報酬をクリック<br />
                    ④先月分が閲覧できる
                    <Divider />
                  </div>
                  <p>2. 申し込みURLが適正でない場合がある</p>
                  ※被紹介者の申し込みがアンバサダー経由で確認できたとしても、
                  URLに紹介者の特定できるコードが入っていない場合は実績に反映いたしません。
                </div>
              }
            />
            <ChildQuestions
              title={"報酬が発生する際の審査基準にはどのようなものがありますか？"}
              desc={
                <div>
                  <p>■ユーザが本商品の新規ユーザではなかった場合</p>
                  <span>現在または過去に一度でもナッシュをご利用された方は、新規ユーザとはならず、報酬対象外となります。</span>
                  <p>■本商品を購入したユーザが、アンバサダーと同一住所の方である場合</p>
                  <span>アンバサダーから紹介のあったユーザが、アンバサダーと同じ住所の方で合った場合は、報酬対象外となります。またこれには電話番号が同じであった場合も含まれます。</span>
                  <p>■ユーザが本商品の既存ユーザ（過去にユーザであった者を含む）と同一住所の者である場合</p>
                  <span>アンバサダーから紹介のあったユーザが、現在または過去に一度でもナッシュをご利用されたことのある住所である場合は、報酬対象外となります。</span>
                  <p>■ユーザが、アンバサダーの専用ページを経由して本商品を購入したことを当社において確認できなかった場合</p>
                  <span>ご紹介いただいたユーザの方が、アンバサダーの専用ページで発行されるURLにアンバサダーが特定できるコード（パラメータ）が入っていない状態で購入された場合は、報酬対象外になります。</span><br />
                  <span>※被紹介者の申し込みがアンバサダー経由で確認できたとしても、 URLに紹介者の特定できるコードが入っていない場合は実績にも反映いたしません。</span>
                  <p>■返品（受取拒否、長期不在持ち戻りを含みます。）、注文のキャンセル等が行われ、当社から当該ユーザに対して本商品の代金が返金された場合</p>
                  <span>アンバサダーから紹介のあったユーザが本商品を注文されたのち、ユーザがキャンセルや返品をされた場合は、報酬対象外になります。</span>
                  <p>■その他、アンバサダーが未成年や反社会的勢力などの場合</p>
                  <span>アンバサダーの方が、アカウント登録時点で満１８歳以上でなかった場合や反社会的勢力などであった場合は、アカウント登録申請の承認ができかねますので、報酬対象外となります。</span>
                </div>
              }
            />
          </ul>
          <h2>お支払いについて</h2>
          <ul>
            <ChildQuestions
              title={"報酬はいつお支払されますか？"}
              desc={
                "お支払いは、実際に購入された月末締めを行い、翌月末日に報酬をお支払いたします。"
              }
              image={"svg/payment_role.svg"}
              imageName={"ナッシュ アンバサダー お支払サイクル"}
            />
          </ul>
          <h2>本人確認について</h2>
          <ul>
            <ChildQuestions
              title={"本人確認書類は何が必要ですか？"}
              desc={
                "マイナンバーカードか、運転免許証のいずれかが必要となります。"
              }
            />
            <ChildQuestions
              title={"本人確認書類の撮影において注意事項はありますか？"}
              desc={
                <div>
                  <p>①鮮明な撮影ができる明るい場所を選んでください</p>
                  <p>②机や台に置き、手で持っての撮影を避けてください</p>
                  <p>③本人確認書類と同系色となるような背景を避けてください</p>
                  <p>④光で反射しないように撮影してください</p>
                </div>
              }
            />
            <ChildQuestions
              title={"本人(顔写真)の撮影において注意事項はありますか？"}
              desc={
                <div>
                  <p>①鮮明な撮影ができる明るい場所を選んでください</p>
                  <p>②顔に影ができるような場所は避けてください</p>
                  <p>③背景も白背景など鮮明な撮影ができる場所を選んでください</p>
                  <p>④カメラを顔と同じ高さにして撮影してください</p>
                </div>
              }
            />
            <ChildQuestions
              title={"撮影における推奨環境はありますか？"}
              desc={
                <div>
                  <p>下記が推奨となるスマートフォンのバージョンです。</p>
                  <p>iPhone: iOS14・iPhone8以上 ブラウザ:Safari</p>
                  <p>Android: Android10以上 ブラウザ:Chrome</p>
                  <br />
                  <p>また、カメラのピントが合わない場合は下記をお試しください</p>
                  <p>①カメラと被写体のピントが合うまで離して撮影する</p>
                  <p>②カメラレンズの埃や汚れを落とす</p>
                </div>
              }
            />
            <ChildQuestions
              title={"本人確認が正常に完了しない場合はどうすればよいですか？"}
              desc={
                <div>
                  撮影が正常に完了しない場合は、下記が考えられる原因です。
                  <p>
                    ①ブラウザバックを押されて再度、本人確認書類の表面撮影画面に遷移しているため、弊社サービスにて不正なリクエストとしてエラーが発生している。
                  </p>
                  <p>
                    ②内部セッション（15分）の有効期限切れのため
                  </p>
                </div>
              }
            />

          </ul>
        </div>
      </Container>
    </div>
  );
};

export default Faq;
